const translations = {
    connectionError: 'Could not reach mix-order service — retry?'
};

export default translations;
